import {Modal} from "antd";
import {t} from '@lingui/macro';

export function UnsavedChangePrompt(callback) {
    Modal.confirm({
        title: t`You have unsaved changes`,
        content: t`Do you really want to navigate away without saving the changes first?`,
        onOk() {
            callback(true);
        },
        onCancel() {
            callback(false);
        },
    });
}
